import { nanoid } from 'nanoid';
import { useField } from 'react-final-form';
import { uniqBy } from 'lodash-es';
import { Domaine, Item, Matiere } from 'types/programmations';
import _isEmpty from 'lodash-es/isEmpty';

export function useSelectProgItem() {
  const boField = useField('bo');
  const attachmentsField = useField('attachments');
  const flowField = useField('flow');
  const flow = flowField.input.value;
  const bo = boField.input.value;
  const attachments = attachmentsField.input.value;

  return (programmationItem: Item, matiere: Matiere, domaine: Domaine) => {
    let newBo = { ...bo };
    if (!_isEmpty(matiere.name)) {
      newBo = {
        ...newBo,
        matiere: uniqBy(
          [...newBo.matiere, { id: nanoid(5), value: matiere.name }],
          'value',
        ),
      };
    }
    if (!_isEmpty(domaine.name)) {
      newBo = {
        ...newBo,
        domaine: uniqBy(
          [...newBo.domaine, { id: nanoid(5), value: domaine.name }],
          'value',
        ),
      };
    }
    boField.input.onChange(newBo);
    if (attachments === undefined || attachments.length === 0) {
      attachmentsField.input.onChange(programmationItem.attachments);
    }

    flowField.input.onChange(`${flow}${programmationItem.value}`);
  };
}
